import React, { useContext, useEffect, useState } from 'react';
import TeacherQuestionLibrary from './Components/TeacherQuestionLibrary';
import TeacherAssessmentLibrary from './Components/TeacherAssessmentLibrary';
import LatestAssessments from './Components/LatestAssessments';
import ExamCountSubjects from './Components/ExamCountSubjects';
import ExamCountGrades from './Components/ExamCountGrades';
import TeacherAnnouncement from './Components/TeacherAnnouncements';
import Teacher from './Components/imageFiles/Teacher.png';
import { MainContext } from '../../../../../context/main/main-context';
import ExamStatusStatistics from './Components/ExamStatusStatistics';

export default function TheTeacherDashboard({
  totalCountMyAssessments,
  totalCountPublicAssessments,
  questionCount,
  categoryCount,
  typeCount,
  subjectCount,
  managedAssessments,
  suitableArray,
  myAssessmentsLoading,
  loadingQuestions,
  loadingCategories,
  dashboardDataLoading
}) {

  const {
    fetchAssesorTeacherDashboardData,
    assesor_dashboard_data,
    assesor_dashboard_data_loading,
    assesor_dashboard_initial_loading,

    fetchReviewerDashboardData,
    reviewer_dashboard_initial_loading,
    reviewer_dashboard_data_loading,
    reviewer_dashboard_data
  } = useContext(MainContext)

  const [allRecentAnnouncements, setAllRecentAnnouncements] = useState([]);
  const [weeklyAnnouncements, setWeeklyAnnouncements] = useState([]);
  const [monthlyAnnouncements, setMonthlyAnnouncements] = useState([]);
  const [myPapersCount, setMyPapersCount] = useState([]);
  const [assignedLatestAssessments, setAssignedLatestAssessments] = useState([])

  const [assessmentCounts, setAssessmentCounts] = useState(null);

  const [employeeType, setEmployeeType] = useState(sessionStorage.getItem("employeeType"))
  const [user_id, setUserId] = useState(sessionStorage.getItem("manage_user_id"))

  const [paper_count_on_subject, set_paper_count_on_subject] = useState([]);
  const [paper_count_on_grade, set_paper_count_on_grade] = useState([]);


  useEffect(() => {
    setEmployeeType(sessionStorage.getItem("employeeType"))
    setUserId(sessionStorage.getItem("manage_user_id"))
    
  }, [])

  useEffect(() => {

    if(employeeType && employeeType === "TEACH" && user_id){
      fetchReviewerDashboardData(user_id)
    }
    else if(employeeType && (employeeType === "MASAD"|| employeeType === "DEOP")){
      fetchAssesorTeacherDashboardData()
    }

  }, [employeeType,user_id])

  useEffect(() => {
    if (assesor_dashboard_data && assesor_dashboard_data.success && assesor_dashboard_data.data) {

      const data = assesor_dashboard_data.data.announcement_data || [];
      const allAssessmentCounts = assesor_dashboard_data.data.assessment_counts || [];

      const filteredAssessmentCounts = allAssessmentCounts.filter(item => {
        const masadStatuses = ["Initial", "Ready", "ProofReading", "Review", "Published", "InReview", "ReferBack", "ReviewCompleted", "ReadyToPublish"];
        const teachStatuses = ["Review", "Published", "InReview", "ReferBack", "ReviewCompleted", "ReadyToPublish"];

        if (employeeType === "MASAD" || employeeType === "DEOP") {
          return masadStatuses.includes(item.status_name);
        } else if (employeeType === "TEACH") {
          return teachStatuses.includes(item.status_name);
        }
        return false;
      });

      setAssessmentCounts(filteredAssessmentCounts);

      setAllRecentAnnouncements(data.all_recent_announcement || []);
      setWeeklyAnnouncements(data.weekly_announcement || []);
      setMonthlyAnnouncements(data.monthly_announcement || []);

      set_paper_count_on_subject(assesor_dashboard_data.data.paper_count_on_subject)
      set_paper_count_on_grade(assesor_dashboard_data.data.paper_count_on_grade)
    }
  }, [assesor_dashboard_data, employeeType]); 

  useEffect(() => {
    
    if(reviewer_dashboard_data && reviewer_dashboard_data.success && reviewer_dashboard_data.data){

      const data = reviewer_dashboard_data.data
      
      setAssessmentCounts(data.assessment_counts || [])
      setAllRecentAnnouncements(data.announcement_data.all_recent_announcement || []);
      setWeeklyAnnouncements(data.announcement_data.weekly_announcement || []);
      setMonthlyAnnouncements(data.announcement_data.monthly_announcement || []);
      setMyPapersCount(data.my_papers_count)
      setAssignedLatestAssessments(data.assigned_latest_assessments)
      
    }
  }, [reviewer_dashboard_data])
  


  return (
    <div className="teacher-dashboard-fluid pt-3">
      <div className="row">
        {/* Assessments */}
        {(employeeType === "MASAD" || employeeType === "DEOP") &&
          <div className="col-lg-2 col-md-6 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <TeacherQuestionLibrary
                  questionCount={questionCount}
                  categoryCount={categoryCount}
                  loadingCategories={loadingCategories}
                  loadingQuestions={loadingQuestions}
                  employeeType={employeeType}
                />
              </div>
            </div>
          </div>
        }

        {/* Assessment Review counts for MASAD and DEOP*/}
        {(employeeType === "MASAD" || employeeType === "DEOP") &&
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <TeacherAssessmentLibrary
                  totalCountMyAssessments={totalCountMyAssessments}
                  totalCountPublicAssessments={totalCountPublicAssessments}
                  loadingQuestions={loadingQuestions}
                  assessmentCounts={assessmentCounts}
                  employeeType={employeeType}
                  typeCount={typeCount}
                  subjectCount={subjectCount}
                  initial_loading={assesor_dashboard_initial_loading}
                />
              </div>
            </div>
          </div>
        }
        {/* Assessment Review counts for TEACH*/}
        {employeeType === "TEACH" &&
          <div className="col-lg-4 col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                   <TeacherAssessmentLibrary
                    totalCountMyAssessments={totalCountMyAssessments}
                    totalCountPublicAssessments={totalCountPublicAssessments}
                    loadingQuestions={loadingQuestions}
                    assessmentCounts={assessmentCounts}
                    employeeType={employeeType}
                    typeCount={typeCount}
                    subjectCount={subjectCount}
                    initial_loading={reviewer_dashboard_initial_loading}
                  />
                </div>
              </div>
            </div>
        }


        {/* Character Image (Placeholder Only) */}
        <div className="col-lg-2 d-none d-lg-block mb-4">
          <div className="card text-center teacher-image">
            <div className="-flex align-items-center justify-content-center">
              <img
                src={Teacher}
                alt="Placeholder character"
                className="img-fluid"
              />
            </div>
          </div>
        </div>

        {/* Latest Assessments */}
        {(employeeType === "MASAD" || employeeType === "DEOP") &&
          <div className="col-lg-4 mb-4">
            <div className="card h-100 latest-assessments">
              <div className="">
                <LatestAssessments managedAssessments={managedAssessments} myAssessmentsLoading={myAssessmentsLoading} />
              </div>
            </div>
          </div>
        }
        {employeeType === "TEACH" &&
          <div className="col-lg-6 md-12 mb-6">
            <div className="card h-100 latest-assessments">
              <div className="">
                <LatestAssessments managedAssessments={assignedLatestAssessments} myAssessmentsLoading={reviewer_dashboard_initial_loading} />
              </div>
            </div>
          </div>
        }
      </div>

      <div className="row">
        {/* Announcements */}
        {(employeeType === "MASAD" || employeeType === "DEOP") &&
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <TeacherAnnouncement
                  allRecentAnnouncements={allRecentAnnouncements}
                  weeklyAnnouncements={weeklyAnnouncements}
                  monthlyAnnouncements={monthlyAnnouncements}
                  initial_loading={assesor_dashboard_initial_loading}
                />
              </div>
            </div>
          </div>
        }
        {employeeType === "TEACH" &&
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <TeacherAnnouncement
                  allRecentAnnouncements={allRecentAnnouncements}
                  weeklyAnnouncements={weeklyAnnouncements}
                  monthlyAnnouncements={monthlyAnnouncements}
                  initial_loading={reviewer_dashboard_initial_loading}
                />
              </div>
            </div>
          </div>
        } 

        {/* Exam Count Sections */}
        {(employeeType === "MASAD" || employeeType === "DEOP")&&
          <>
            <div className="col-lg-4 md-6 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <ExamCountSubjects paper_count_on_subject={paper_count_on_subject} dashboardDataLoading={assesor_dashboard_initial_loading} />
                </div>
              </div>
            </div>

            <div className="col-lg-4 md-6 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <ExamCountGrades paper_count_on_grade={paper_count_on_grade} dashboardDataLoading={assesor_dashboard_initial_loading} />
                </div>
              </div>
            </div>
          </>
        }

        
      

      {(employeeType === "MASAD" || employeeType === "DEOP")&&
        // <div className="row">
          <div className='col-md-12 mb-4'>
            <ExamStatusStatistics dashboard_data={assesor_dashboard_data} initial_loading={assesor_dashboard_initial_loading} employeeType={employeeType}/>
          {/* </div> */}
        </div>
      }
      {employeeType === "TEACH" &&
        // <div className="row">
          <div className='col-lg-8 md-12 sm-12 mb-4'>
            <ExamStatusStatistics dashboard_data={reviewer_dashboard_data} initial_loading={reviewer_dashboard_initial_loading} employeeType={employeeType}/>
          {/* </div> */}
        </div>
      }
      </div>
    </div>
  );
}
